import { createSlice } from "@reduxjs/toolkit"

const storedUser = sessionStorage.getItem("userDetails");
let parsedUser = null;

try {
  parsedUser = storedUser ? JSON.parse(storedUser).role : null;
} catch (error) {
  parsedUser = null;
}


export const AdminReducer= createSlice({
name: 'adminReducer',
  initialState:{
     user: parsedUser,
  },
  reducers: {
    setUser: (state,action) => {
      state.user = action.payload
    },
     clearUser: (state) => {
      state.user = null;
    }
   
  },
})

export const { setUser, clearUser } = AdminReducer.actions

export default AdminReducer.reducer